import { ContextType } from "./context-type.enum";
import { NextStepDeciderConfig } from "./next-step-decider-config.model";
import { StepConfig } from "./step-config.model";
import { StepType } from "./step-type.enum";
import { Option } from "../../../models/wizard/option.model";
import { OptionUtils } from "../../../models/wizard/option-utils";

export class GatherLeadSourceStepConfig extends StepConfig {

  private static _allLeadSourceOptions: Option[] = [
    OptionUtils.create('leadSource.socialMedia',     'Social Media',       'Social Media',       'Social Media',       'Social Media'),
    OptionUtils.create('leadSource.realEstateAgent', 'Real Estate Agent',  'Real Estate Agent',  'Real Estate Agent',  'Real Estate Agent'),
    OptionUtils.create('leadSource.internet',        'Internet',           'Internet',           'Internet',           'Internet'),
    OptionUtils.create('leadSource.pastClients',     'Past Clients',       'Personal Referral',  'Personal Referral',  'Past Clients'),
    OptionUtils.create('leadSource.returningClient', 'Returning Client',   'Returning Client',   'Returning Client',   'Returning Client'),
    OptionUtils.create('leadSource.radio',           'Radio',              'Radio',              'Radio',              'Radio'),
    OptionUtils.create('leadSource.letterInTheMail', 'Letter in the Mail', 'Letter in the Mail', 'Letter in the Mail', 'Letter in the Mail'),
    OptionUtils.create('leadSource.other',           'Other',              'Other',              'Other',              'Other'),
  ]

  static get allLeadSourceOptions(): Option[] {
    return [...GatherLeadSourceStepConfig._allLeadSourceOptions];
  }

  pickAgentReferralFromAList: boolean = true;

  leadSourceOptions: Option[] = GatherLeadSourceStepConfig.allLeadSourceOptions;

  constructor(id: string, name: string | undefined, path: string, groupId: number | undefined, nextStepDeciderConfig: NextStepDeciderConfig | undefined) {
    super(id, name, path, groupId, ContextType.None);
    this.stepType = StepType.GatherLeadSourceStep;
    this.nextStepDeciderConfig = nextStepDeciderConfig;
    this.pickAgentReferralFromAList = true;
  }
}
